import { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaFileImport } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import JSZip, { forEach } from "jszip";
import { useDispatch } from 'react-redux';
import { updateJsonData } from '../../../store/jsonSlice';
import axios from 'axios';


const LanguageManageLearn = () => {

  // Fonction pour télécharger tout le contenu du dossier de langue (images, sons, json, glb, pdf, etc.) en ZIP côté frontend
  const handleDownloadJson = async (folder) => {
    setDownloadError(null);
    try {
      // 1. Récupérer la liste de tous les fichiers du dossier
      const listResponse = await fetch(`/api/data/${encodeURIComponent(chapterName)}/${encodeURIComponent(folder)}/list-all-files`, { credentials: 'include' });
      if (!listResponse.ok) {
        const err = await listResponse.json().catch(() => ({}));
        throw new Error(err.error || `Status ${listResponse.status}`);
      }
      const files = await listResponse.json(); // tableau de noms de fichiers
      const zip = new JSZip();
      // 2. Télécharger chaque fichier et l'ajouter dans le zip
      await Promise.all(files.map(async (filename) => {
        const fileUrl = `/api/data/${encodeURIComponent(chapterName)}/${encodeURIComponent(folder)}/${encodeURIComponent(filename)}`;
        const fileResp = await fetch(fileUrl, { credentials: 'include' });
        if (!fileResp.ok) throw new Error(`Erreur lors du téléchargement de ${filename}`);
        const blob = await fileResp.blob();
        zip.file(filename, blob);
      }));
      // 3. Générer le ZIP et déclencher le téléchargement
      const zipBlob = await zip.generateAsync({ type: 'blob' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(zipBlob);
      link.download = `${folder}_export.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error(err);
      setDownloadError(err.message);
    }
  };



  const dispatch = useDispatch();

  // Nouvelle fonction pour charger le JSON et naviguer
  const handleSelectFolder = async (folder) => {
    try {
      const filename = `${folder}_learn.json`;
      const response = await fetch(
        `/api/data/${encodeURIComponent(chapterName)}/${encodeURIComponent(folder)}/learn/${encodeURIComponent(filename)}`,
        { credentials: 'include' }
      );
      if (!response.ok) throw new Error('Erreur lors du chargement du JSON');
      const data = await response.json();
      dispatch(updateJsonData(data));
      navigate(`/homemonoLearn/${chapterName}/${encodeURIComponent(filename)}`); // Redirige vers la version Learn
    } catch (err) {
      alert('Impossible de charger ce JSON : ' + err.message);
    }
  };
  const [languageFolders, setLanguageFolders] = useState([]); // [{folder, lang, hasLearn}]
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isCreatingFolder, setIsCreatingFolder] = useState(false);
  const [newFolderSuffix, setNewFolderSuffix] = useState("");
  const [createFolderError, setCreateFolderError] = useState(null);
  const [deleteFolderError, setDeleteFolderError] = useState(null);
  const [downloadError, setDownloadError] = useState(null);
  const [folderName, setFolderName] = useState("");
  const [filename, setFilename] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [importError, setImportError] = useState(null);
  const [folders, setFolders] = useState([]); // Liste des dossiers pour l'import
  // Pour la duplication :
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
  const [duplicateBaseFolder, setDuplicateBaseFolder] = useState("");
  const [duplicateSuffix, setDuplicateSuffix] = useState("");
  const [duplicateError, setDuplicateError] = useState("");
  const [suffix, setSuffix] = useState("");

  const navigate = useNavigate();
  const { chapterName } = useParams();

  // Nouvelle version : utilise la route /api/verif-learn-file pour récupérer la liste des langues et la présence du learn.json
  const fetchLanguageFolders = async () => {
    try {
      const response = await axios.get(`/api/verif-learn-file/${chapterName}`, { withCredentials: true });
      //  if (!response.ok) throw new Error(response.statusText);
      //const data = await response.json();
      console.log(response);
      // On ne garde que les langues du chapitre courant
      // const filtered = data.filter(item => item.folder === chapterName);
      setLanguageFolders(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError(err);
      setLoading(false);
    }
  };

  // Crée le fichier learn.json pour une langue donnée
  const handleCreateLearnFile = async (lang) => {
    try {
      const response = await fetch('/api/create-learn-file', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ folder: chapterName, lang }),
        credentials: 'include'
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Status ${response.status}`);
      }
      alert('Fichier learn.json créé avec succès pour ' + lang);
      fetchLanguageFolders();
    } catch (err) {
      alert('Erreur lors de la création du fichier learn.json : ' + err.message);
    }
  };

  useEffect(() => {
    if (chapterName) {
      fetchLanguageFolders();
    }
  }, [chapterName]);

  //const handleGoBack = () => navigate(-1);
  const handleGoBack = () => navigate(`/chapterManageLearn`);

  const handleCreateFolderClick = () => {
    setIsCreatingFolder(true);
    setNewFolderSuffix("");
    setCreateFolderError(null);
  };

  const handleNewFolderSuffixChange = (e) => {
    setNewFolderSuffix(e.target.value);
  };

  const handleCancelCreateFolder = () => {
    setIsCreatingFolder(false);
    setNewFolderSuffix("");
    setCreateFolderError(null);
  };


  const handleCreateFolder = async () => {
    if (!newFolderSuffix.trim()) {
      setCreateFolderError("Le suffixe du dossier est requis.");
      return;
    }

    // Correction : garder les espaces et caractères d'origine dans le nom du dossier et du fichier
    const folderName = `${chapterName}_${newFolderSuffix.trim().toUpperCase()}`;
    const jsonFilename = `${folderName}.json`;
    const fullFolderName = folderName;

    try {
      // Créer le dossier (nom exact, pas de sanitize)
      const response = await fetch("/api/data/create-folder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ folderName: `${chapterName}/${fullFolderName}` }),
      });

      if (!response.ok) throw new Error(`Erreur lors de la création du dossier: ${await response.text()}`);

      // Créer le fichier JSON initial avec la structure Redux
      const initialJson = {
        usage: "",
        settings: {
          contentVersion: 0,
          ownerName: "",
          ownerIdentifier: "",
          appVersion: "",
          chapter: "",
          calibrateAfterStageID: 0
        },
        process: {
          processTitle: "",
          processDesc: "",
          workspaceShape: "",
          workspaceShapeSize: { x: 0, y: 0, z:0 },
          workspaceShapeRot: { x: 0, y: 0, z: 0 },
          workspaceOffsetPos: { x: 0, y: 0, z: 0 },
          workspaceOffsetRot: { x: 0, y: 0, z: 0 },
          mainHologram: "",
          steps: [],
          stages: []
        }
      };

      // Sauvegarder le fichier JSON avec le nom exact
      const saveResponse = await fetch(`/api/data/${encodeURIComponent(chapterName)}/${encodeURIComponent(folderName)}/${encodeURIComponent(jsonFilename)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(initialJson),
        credentials: 'include'
      });

      if (!saveResponse.ok) throw new Error(`Erreur lors de la création du fichier JSON: ${await saveResponse.text()}`);

      // Mettre à jour la liste des dossiers
      setLanguageFolders((prev) => [...prev, fullFolderName]);
      setIsCreatingFolder(false);
      setNewFolderSuffix("");

      // Initialiser le JSON dans Redux
      dispatch(updateJsonData(initialJson));

      // Rediriger vers HomeMonoPage avec le bon nom de fichier JSON
      navigate(`/homemonoLearn/${encodeURIComponent(folderName)}/${encodeURIComponent(jsonFilename)}`);
    } catch (err) {
      console.error(err);
      setCreateFolderError(err.message);
    }
  };

  const handleDeleteFolder = async (folder) => {
    // Confirmation avant suppression
    const confirmDelete = window.confirm(`⚠️ A T T E N T I O N ⚠️
      Êtes-vous sûr de vouloir supprimer définitivement la variante linguistique "${folder}" ?`);
    if (!confirmDelete) return;

    setDeleteFolderError(null);
    try {
      const res = await fetch(`/api/data/delete-language-folder/${chapterName}/${folder}`, { method: 'DELETE', credentials: 'include' });
      let errorMessage = `Status ${res.status}`;
      try {
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const err = await res.json();
          errorMessage = err.error || errorMessage;
        } else {
          const text = await res.text();
          errorMessage = text.slice(0, 200); // Limit error text length
        }
      } catch (parseErr) {
        console.error('Erreur lors du parsing de la réponse :', parseErr);
      }

      if (!res.ok) {
        throw new Error(errorMessage);
      }
      fetchLanguageFolders();
    } catch (err) {
      console.error(err);
      setDeleteFolderError(err.message);
    }
  };

  // Ouvre la boîte de dialogue de duplication
  const openDuplicateDialog = (folder) => {
    const learnFolders = [];
    for (const item of folder) {
      if (item.hasLearn) {
        learnFolders.push(item);
      }
    }
    setFolders(learnFolders);
    setDuplicateSuffix("");
    setDuplicateError("");
    setDuplicateDialogOpen(true);
  };

  // Ferme la boîte de dialogue de duplication
  const closeDuplicateDialog = () => {
    setDuplicateDialogOpen(false);
    setDuplicateBaseFolder("");
    setDuplicateSuffix("");
    setDuplicateError("");
  };

  // Gère la duplication après saisie du suffixe/langue
  const confirmDuplicateFolder = async () => {
    setDownloadError(null);
    setDuplicateError("");
    const folder = duplicateBaseFolder;
    console.log(`Dupliquer la variante : ${folder}`);
    /* const suffix = duplicateSuffix.trim();
     if (!suffix) {
       setDuplicateError("Veuillez saisir un code langue ou suffixe valide.");
       return;
     }*/
    // Nouveau nom : baseFolder sans suffixe existant + _SUFFIX (suffixe forcé en MAJUSCULE)
    let baseName = folder.replace(/(_[a-zA-Z0-9]+)?$/, "");
    console.log(`Base name pour duplication : ${baseName}`);
    let newFolderName = baseName + "_" + suffix.toUpperCase();
    console.log(`Nouveau nom de dossier : ${newFolderName}`);
    if (languageFolders.includes(newFolderName)) {
      setDuplicateError("Une variante avec ce nom existe déjà.");
      return;
    }
    try {
      const response = await fetch(`/api/data/duplicate-learn-folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chapterName, folder, newFolderName }),
        credentials: 'include'
      });
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || `Status ${response.status}`);
      }
      fetchLanguageFolders();
      closeDuplicateDialog();
      alert(`Variante dupliquée sous le nom : ${newFolderName}`);
    } catch (err) {
      setDuplicateError('Erreur lors de la duplication : ' + err.message);
    }
  };

  // Suppression du dossier learn d'une langue
  const handleDeleteLearnFolder = async (lang) => {
    if (!window.confirm(`⚠️ A T T E N T I O N ⚠️
    Êtes-vous sûr de vouloir supprimer définitivement la variante ${lang} ?
    Cette action est irréversible.`)) return;
    try {
      const response = await fetch('/api/delete-learn-folder', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ folder: chapterName, lang }),
        credentials: 'include'
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Status ${response.status}`);
      }
      alert('Dossier learn supprimé pour ' + lang);
      fetchLanguageFolders();
    } catch (err) {
      alert('Erreur lors de la suppression du dossier learn : ' + err.message);
    }
  };

  if (loading) return <div>Chargement...</div>;
  if (error) return <div className="alert alert-danger">{error.message}</div>;



  // Fonction pour dupliquer une variante
  const handleDuplicateFolder = async (folder) => {
    setSuffix(folder.split('_')[folder.split('_').length - 1]); // Récupère le suffixe de la variante
    const baseName = folder.split('_')[0];
    //console.log(`Dupliquer la variante : ${suffix}`);
    const response = await axios.get(`/api/verif-learn-file/${baseName}`, { withCredentials: true });
    console.log(response);
    openDuplicateDialog(response);
  };

  return (
    <div className="page-content">
      <div className="container mt-8">
        <div className="card shadow-sm p-4 position-relative">
          <h1 className='text-primary text-center'>iXiMAKER - Learn</h1>
          <h2 className="text-tertiary mb-2 text-center">{chapterName}</h2>
          <h3 className="text-primary text-center">Variantes et variantes</h3>
          <p className="text-secondary text-center mb-4">Sélectionnez la langue pour créer ou éditer vos formations iXiLEARN pour {chapterName}.</p>
          {/* Boîte de dialogue de duplication */}
          {duplicateDialogOpen && (
            <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.2)' }} tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title text-primary">Importer une formation</h5>
                    <button type="button" className="btn-close" aria-label="Fermer" onClick={closeDuplicateDialog}></button>
                  </div>
                  <div className="modal-body">
                    <p className="text-center text-secondary ">Sélectionnez <b>une version linguistique existante</b><br />
                      Tous les contenus seront <b>remplacés</b> pas cette source.</p>
                    <div className="mb-3">
                      <label className="form-label">Formation à importer</label>
                      <select
                        className="form-select"
                        value={duplicateBaseFolder}
                        onChange={e => setDuplicateBaseFolder(e.target.value)}
                      >
                        <option value="">Sélectionner une source</option>
                        {folders.map((folder, index) => (
                          <option key={index} value={folder.lang}>{folder.lang}</option>
                        ))}
                      </select>
                      {duplicateError && <div className="alert alert-danger mt-2">{duplicateError}</div>}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={closeDuplicateDialog}>Annuler</button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={duplicateBaseFolder.trim() === ""}
                      onClick={confirmDuplicateFolder}>
                      Dupliquer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="container mt-4">
            {languageFolders.length === 0 ? (
              <div className="alert alert-info text-center">Aucune formation disponible</div>
            ) : (
              <div className="row" alt="liste des variantes">
                {languageFolders.map(({ lang, hasLearn }) => (
                  <div alt="gestion du learn existant" className="col-md-6 mb-1" key={lang}>
                    <div className="shadow-sm border rounded p-2 mb-2">
                      <div className="row" alt="button">
                        <div className="col-10" alt="Titre de la variante">
                          <button
                            className="btn btn-link text-decoration-none text-primary p-0"
                            style={{ textAlign: 'left' }}
                            onClick={() => {
                              const folderName = lang;
                              const filename = `${lang}_learn.json`;
                              navigate(`/homemonoLearn/${encodeURIComponent(folderName)}/${encodeURIComponent(filename)}`);
                            }}
                          >
                            <span className="ms-2 fs-4"><i className='mdi mdi-school-outline me-2'></i>{lang}</span>
                          </button>
                        </div>
                        <div className="col-2 d-flex justify-content-end ms-auto gap-2" alt="boutons d'édition">
                          {hasLearn ? (
                            <>
                              <button
                                className="btn btn-sm btn-outline-primary "
                                onClick={() => {
                                  const folderName = lang;
                                  const filename = `${lang}_learn.json`;
                                  navigate(`/homemonoLearn/${encodeURIComponent(folderName)}/${encodeURIComponent(filename)}`);
                                }}
                                title="Éditer cette formation"
                              >
                                <FaEdit />
                              </button>
                              {/*<button
                                className="btn btn-sm btn-outline-success"
                                onClick={() => handleDownloadJson(lang)}
                                title="Télécharger le contenu de la formation"
                              >
                                <FaFileImport />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleDuplicateFolder(lang)}
                                title="Importer une variante linguistique"
                              >
                                <FaFileImport />
                              </button>*/}
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDeleteLearnFolder(lang)}
                                title="⚠️ATTENTION⚠️
                              Supprimer DEFINITIVEMENT cette version?"
                              >
                                <FaTrash />
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-sm btn-outline-primary"
                                style={{ minWidth: 140, whiteSpace: "nowrap" }}
                                onClick={() => handleCreateLearnFile(lang)}
                                title="Créer un contenu vierge pour cette langue"
                              >
                                + Contenu vierge
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleDuplicateFolder(lang)}
                                title="Importer une variante existante"
                              >
                                <FaFileImport />
                              </button>
                            </>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="col-md-12 d-flex justify-content-center" alt="retour/gestion des variantes">
              <div className="col-md-5 mb-3 mt-4 d-flex justify-content-center">
                <button className="btn btn-outline-danger" onClick={handleGoBack}>
                  <i className="mdi mdi-arrow-left-bold fs-3 align-middle"></i> Retour aux formations
                </button>
              </div>
            </div>

            {downloadError && <div className="alert alert-danger mt-2">{downloadError}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};



export default LanguageManageLearn;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
